import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import { PageContentBlockWithTitleStyle } from '../../../styles/components/common/blocks';

export interface IPageContentBlockWithTitleProps {
  title: string;
  text: string;
  iconPath?: string | undefined;
}

const PageContentBlockWithTitle = (props: IPageContentBlockWithTitleProps) => {
  return (
    <div
      className={
        PageContentBlockWithTitleStyle['page-content-block-with-title']
      }>
      <h3>{props.title}</h3>
      <div
        className={
          props.iconPath
            ? PageContentBlockWithTitleStyle[
                'page-content-block-with-title-has-text-icon'
              ]
            : ''
        }>
        {props.iconPath && (
          <Image
            quality={90}
            src={props.iconPath}
            alt={props.title}
            width={40}
            height={40}
          />
        )}
        <div>
          <ReactMarkdown>{props.text}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default PageContentBlockWithTitle;
